import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { addCurrencySymbol } from '@utils/currency/addSymbol';
import SimpleButton from '@components/SimpleButton';
import { ROUTES } from '@services/routes.service';

import messages from './messages';

function GoToCartButton({
  currencySymbol,
  cartSubtotal,
  pushPage,
  trackCartClicked,
  intl: { formatMessage, formatNumber },
  menuSection,
}) {
  const goToCart = useCallback(
    e => {
      e.preventDefault();
      trackCartClicked({ menuSection });
      pushPage(ROUTES.CART);
    },
    [trackCartClicked, menuSection, pushPage],
  );

  const formattedCartSubtotal = useMemo(
    () => addCurrencySymbol(formatNumber(cartSubtotal), currencySymbol),
    [cartSubtotal, currencySymbol, formatNumber],
  );

  return (
    <SimpleButton
      elementId="go__to__cart__button"
      label={formatMessage(messages.button, {
        value: formattedCartSubtotal,
      })}
      color="primary"
      onClick={goToCart}
    />
  );
}

GoToCartButton.propTypes = {
  // redux
  currencySymbol: PropTypes.string.isRequired,
  cartSubtotal: PropTypes.number,

  // callbacks
  pushPage: PropTypes.func.isRequired,

  // tracking
  trackCartClicked: PropTypes.func.isRequired,
  menuSection: PropTypes.string,

  intl: intlShape,
};

export default injectIntl(GoToCartButton);
